import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AssetsPipe } from './assets-pipe';
import { DateFormatPipe } from './date-format.pipe';
import { DateTimeFormatPipe } from './datetime-format.pipe';
import { DurationPipe } from './duration-pipe';
import { TimeFormatPipe } from './time-format.pipe';
import { ShortDateFormat } from './short-date-format.pipe';
import { WorkTimePipe } from './worktime-pipe';

@NgModule({
    declarations: [
        AssetsPipe,
        DateFormatPipe,
        DurationPipe,
        WorkTimePipe,
        DateTimeFormatPipe,
        TimeFormatPipe,
        ShortDateFormat],
    imports: [
        CommonModule
    ],
    exports: [
        AssetsPipe,
        DateFormatPipe,
        DurationPipe,
        WorkTimePipe,
        DateTimeFormatPipe,
        TimeFormatPipe,
        ShortDateFormat]
})

export class PipesModule { }



// WEBPACK FOOTER //
// ./src/app/modules/pipes/pipes.module.ts